// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2_lwh","footer":"ModalUpdate_footer__1_6c7"};